import React from "react";
import Slider from "react-slick";

const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1324,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <>
      <section id="testimonials" className="testimonials" style={{backgroundColor:'black'}}>
        <div className="container " data-aos="fade-up">
          <div className="section-title">
            <h2> <span style={{color:'white'}}>TOP</span> TEDx TALKS</h2>
          </div>
          <div className="p-md-0 p-3">
            <Slider {...settings}>
              <div className="p-2 m-1">
                <div className="video-responsive">
                  <iframe
                    width="853"
                    height="480"
                    src={`https://www.youtube.com/embed/9utZ77XmHBU?si=lvEfyKLvWUSuZDmN`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                  />
                </div>
                <div className="testimonial_content mt-2">
                  <p className="text-white testimonial_content_heading">Rahul Chaudhari : How Passion Fuels Greatness</p>
                  <p>
                  Rahul Chaudhari shares his incredible journey from a young Kabaddi enthusiast to an international sports icon, emphasizing the importance of discipline and perseverance. His story mirrors the power of following your passion, with examples from his own life.
                  </p>
                </div>
              </div>
              <div className="p-2 m-1">
                <div className="video-responsive">
                  <iframe
                    width="853"
                    height="480"
                    src={`https://www.youtube.com/embed/qWk-hneFsXY?si=s4EmB19GVcCS2BJO`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                  />
                </div>
                <div className="testimonial_content mt-2">
                  <p className="text-white testimonial_content_heading">Ruma Devi : Weaving Empowerment for Women</p>
                  <p>
                  Meet Ruma Devi, a woman who defied the odds and transformed her life from the depths of despair to inspiring hope for her entire community. But what led her on this extraordinary journey of resilience and empowerment?
                  </p>
                </div>
              </div>
              <div className="p-2 m-1">
                <div className="video-responsive">
                  <iframe
                    width="853"
                    height="480"
                    src={`https://www.youtube.com/embed/iomL9ZX0RRo?si=wdkS2Bisn85rEG5s`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                  />
                </div>
                <div className="testimonial_content mt-2">
                  <p className="text-white testimonial_content_heading">Kiran Verma : Nurturing Compassion for Life</p>
                  <p>
                  Meet Kiran Verma, an extraordinary individual on a mission to change lives across India.  Kiran's early struggles and near-tragic experiences led him to a powerful realization about the impact of blood donation.
                  </p>
                </div>
              </div>
              <div className="p-2 m-1">
                <div className="video-responsive">
                  <iframe
                    width="853"
                    height="480"
                    src={`https://www.youtube.com/embed/dtiVl0zWqyc?si=NfSiERdVV8iukQMp`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                  />
                </div>
                <div className="testimonial_content mt-2">
                  <p className="text-white testimonial_content_heading">Akshat Gupta : Writing a way to Recovery</p>
                  <p>
                  Akshat found himself at a crossroads, facing the void left by life's unexpected turns. He grappled with the unfamiliar territory of living alone, learning how to be his own anchor. In this soul-searching process, he discovered a source of healing - writing.
                  </p>
                </div>
              </div>
              <div className="p-2 m-1">
                <div className="video-responsive">
                  <iframe
                    width="853"
                    height="480"
                    src={`https://www.youtube.com/embed/szzUdfG9-Xw?si=jehQxWSmvTCkKras`}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                  />
                </div>
                <div className="testimonial_content mt-2">
                  <p className="text-white testimonial_content_heading">Licypriya : A Key to a Free and Sustainable Future </p>
                  <p>
                  Licypriya Kangujam is an inspiring 11-year-old Indian climate activist and founder of the Child Movement. She passionately calls for urgent global action on climate change and urges world leaders to listen to children's powerful voices.
                  </p>
                </div>
              </div>
            </Slider>
          </div>
        </div>
        <div className="container">
            <div className="row mt-5  justify-content-center ">
                <a href="https://www.ted.com/playlists/180/the_10_most_popular_tedx_talks"  target="_blank" rel="noreferrer" className="testimonial_border text-center text-white">View more talks</a>
            </div>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
